/* eslint-disable react-hooks/exhaustive-deps */
import {  useBoolean } from '@chakra-ui/react';
import { useContext } from 'react';
import {
  MyAccountContext,
} from '../../../providers/MyAccountProvider';
import EditAccountsModal from './EditAccountsModal';
import { AuthContext } from '../../../providers/AuthProvider';
import LogoComponent from './LogoComponent';
import { ClientType, getDictionaryKeyForClientTypeData } from '../../../utils/clientTypeUtils';

const HospitalMyAccount = ({ 
  getData,
  GridItemWrapper,
  handleImageSubmit 
}) => {
  const myAccountContext = useContext(MyAccountContext);
  const currentUser = myAccountContext.currentUserType;
  const authContext = useContext(AuthContext)
  const [isAccountModalOpen, setIsAccountModalOpen] = useBoolean(false);
  const CLIENT_TYPE_KEY = getDictionaryKeyForClientTypeData(ClientType.HOSPITAL);

  return (
    <>
    <GridItemWrapper>
      <LogoComponent
      attribute={'logo'} 
      logo={authContext.currentUser[CLIENT_TYPE_KEY]?.logo} 
      handleLogoUpdate={async (key, selectedImage) => {
        await handleImageSubmit(key, selectedImage, CLIENT_TYPE_KEY);
      }}
      GridItemWrapper={GridItemWrapper}
      />
    </GridItemWrapper>
      <EditAccountsModal
        isOpen={isAccountModalOpen}
        onClose={setIsAccountModalOpen.off}
        accountData={currentUser}
        getData={getData}
      />
    </>
  );
};

export default HospitalMyAccount;
